// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fae3ebc5","513":"ebb45fc8","703":"bca13d2e","787":"2fdb2ba5"}[chunkId] + ".chunk.js";
};